/**
 * Kopfzelle fuer Zahlenspalten.
 *
 * Warum eine eigene Komponente: `text-align: right` auf der Kopfzelle wirkt
 * nicht. Fluent legt in `TableHeaderCell` ein eigenes Flex-Layout ab, das die
 * Beschriftung links haelt – die Zahlen darunter stehen dagegen rechts, und
 * die Spalte liest sich dadurch um eine Position versetzt. Die Beschriftung
 * wird deshalb in einen Block gesetzt, der die volle Breite einnimmt und
 * selbst rechts ausrichtet.
 */
import { TableHeaderCell, makeStyles } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  /**
   * Der Block nimmt die volle Breite der Kopfzelle ein und richtet den Text
   * darin rechts aus. Bewusst ohne Kindselektor auf das Fluent-Layout: Dessen
   * Klassennamen sind nicht Teil der oeffentlichen Schnittstelle und koennen
   * sich mit einer neuen Version aendern.
   */
  label: { width: '100%', textAlign: 'right' },
});

export function NumericHeaderCell({ children }: { children: ReactNode }) {
  const styles = useStyles();
  return (
    <TableHeaderCell>
      <span className={styles.label}>{children}</span>
    </TableHeaderCell>
  );
}
